// extracted by mini-css-extract-plugin
export default {"container1":"CardsContainer_container1__7xVdu","paginacion":"CardsContainer_paginacion__xtzni"};